(function () {
  'use strict';
  if (window.LuxeHome) { window.LuxeHome.init(document); return; }

  var LuxeHome = {};
  var INIT = 'data-lxh-init';

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function on(els, ev, fn) { els.forEach(function (el) { el.addEventListener(ev, fn); }); }
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  /* ---------- Favorites arch carousel ---------- */
  function initFav(root) {
    var track = root.querySelector('[data-lxh-fav-track]');
    if (!track) return;
    var cards = $all(track, '.lxh-fav__card');
    var n = cards.length;
    if (!n) return;
    var i = clamp(parseInt(root.getAttribute('data-start'), 10) || 0, 0, n - 1);
    var center = (n - 1) / 2;
    function render() {
      cards.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      track.style.setProperty('--lxh-fav-offset', String(center - i));
      track.style.setProperty('--lxh-fav-index', String(i));
    }
    on($all(root, '[data-lxh-fav-prev]'), 'click', function () { i = (i - 1 + n) % n; render(); });
    on($all(root, '[data-lxh-fav-next]'), 'click', function () { i = (i + 1) % n; render(); });
    cards.forEach(function (c, k) {
      c.addEventListener('click', function (e) {
        if (k === i) return;
        if (e.target.closest('a, button')) return;
        i = k; render();
      });
    });
    swipe(track, function (dir) { i = clamp(i + dir, 0, n - 1); render(); });
    render();
  }

  /* ---------- Pillars panel slider ---------- */
  function initPil(root) {
    var viewport = root.querySelector('.lxh-pil__viewport');
    var track = root.querySelector('[data-lxh-pil-track]');
    if (!track || !viewport) return;
    var panels = $all(track, '.lxh-pil__panel');
    if (!panels.length) return;
    var i = 0;
    var prevs = $all(root, '[data-lxh-pil-prev]');
    var nexts = $all(root, '[data-lxh-pil-next]');
    function step() { return panels[1] ? panels[1].offsetLeft - panels[0].offsetLeft : panels[0].offsetWidth; }
    function maxX() { return Math.max(0, track.scrollWidth - viewport.clientWidth); }
    function render() {
      var x = Math.min(i * step(), maxX());
      track.style.setProperty('--lxh-pil-x', String(x));
      var atEnd = x >= maxX() - 1;
      prevs.forEach(function (b) { b.disabled = i === 0; });
      nexts.forEach(function (b) { b.disabled = atEnd; });
    }
    on(prevs, 'click', function () { i = Math.max(0, i - 1); render(); });
    on(nexts, 'click', function () { if (i * step() < maxX() - 1) { i += 1; } render(); });
    swipe(track, function (dir) { if (dir > 0) { if (i * step() < maxX() - 1) i += 1; } else { i = Math.max(0, i - 1); } render(); });
    window.addEventListener('resize', debounce(render, 120));
    render();
  }

  /* ---------- Ritual rotating list ---------- */
  function initRitual(list) {
    var items = $all(list, '[data-lxh-rit-item]');
    if (!items.length) return;
    var i = 0, timer = null;
    var interval = (parseInt(list.getAttribute('data-interval'), 10) || 0) * 1000;
    function render() { items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); }); }
    function go(k) { i = (k + items.length) % items.length; render(); restart(); }
    function restart() {
      if (timer) clearInterval(timer);
      if (interval > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(function () { i = (i + 1) % items.length; render(); }, interval);
      }
    }
    on($all(list, '[data-lxh-rit-prev]'), 'click', function () { go(i - 1); });
    on($all(list, '[data-lxh-rit-next]'), 'click', function () { go(i + 1); });
    items.forEach(function (el, k) { el.addEventListener('click', function () { go(k); }); });
    render(); restart();
  }

  /* ---------- Testimonial slider ---------- */
  function initTes(root) {
    var slides = $all(root, '[data-lxh-tes-slide]');
    if (!slides.length) return;
    var i = 0;
    function render() { slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); }); }
    on($all(root, '[data-lxh-tes-prev]'), 'click', function () { i = (i - 1 + slides.length) % slides.length; render(); });
    on($all(root, '[data-lxh-tes-next]'), 'click', function () { i = (i + 1) % slides.length; render(); });
    swipe(root.querySelector('.lxh-tes__slides'), function (dir) { i = (i + dir + slides.length) % slides.length; render(); });
    render();
  }

  /* ---------- Add to bag ---------- */
  function initBag(btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-lxh-add');
      if (!id || btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      var body = { items: [{ id: parseInt(id, 10), quantity: 1 }], sections_url: window.location.pathname };
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          btn.classList.remove('is-busy');
          if (!res.ok) { throw new Error(res.json && res.json.description || 'Add to cart failed'); }
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1500);
          var item = res.json && res.json.items ? res.json.items[0] : res.json;
          /* Focal: variant:added refreshes and opens the drawer; cart:refresh as a fallback for other themes. */
          document.documentElement.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: item } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        })
        .catch(function (err) {
          btn.classList.remove('is-busy');
          if (window.console) console.warn('[luxe-home] ' + err.message);
        });
    });
  }

  /* ---------- helpers ---------- */
  function swipe(el, cb) {
    if (!el) return;
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) cb(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
  function once(el, fn) { if (el.hasAttribute(INIT)) return; el.setAttribute(INIT, '1'); fn(el); }

  /* ---------- Mobile scroll-snap slider arrows ---------- */
  function initScrollZone(zone) {
    var sc = zone.querySelector('[data-lxh-scroll]');
    if (!sc) return;
    function step() {
      var card = sc.firstElementChild;
      if (!card) return sc.clientWidth;
      var gap = parseFloat(getComputedStyle(sc).columnGap || getComputedStyle(sc).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    on($all(zone, '[data-lxh-scroll-prev]'), 'click', function () { sc.scrollBy({ left: -step(), behavior: 'smooth' }); });
    on($all(zone, '[data-lxh-scroll-next]'), 'click', function () { sc.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  LuxeHome.init = function (scope) {
    scope = scope || document;
    $all(scope, '[data-lxh-fav]').forEach(function (el) { once(el, initFav); });
    $all(scope, '[data-lxh-pil]').forEach(function (el) { once(el, initPil); });
    $all(scope, '[data-lxh-ritual]').forEach(function (el) { once(el, initRitual); });
    $all(scope, '[data-lxh-tes]').forEach(function (el) { once(el, initTes); });
    $all(scope, '[data-lxh-add]').forEach(function (el) { once(el, initBag); });
    $all(scope, '[data-lxh-szone]').forEach(function (el) { once(el, initScrollZone); });
  };

  /* Theme editor: selecting a block activates its slide/card */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var slide = el.closest ? el : null;
    if (!slide) return;
    var tes = el.closest('[data-lxh-tes]');
    if (tes && el.hasAttribute('data-lxh-tes-slide')) {
      $all(tes, '[data-lxh-tes-slide]').forEach(function (s2) { s2.classList.toggle('is-active', s2 === el); });
      return;
    }
    var fav = el.closest('[data-lxh-fav]');
    if (fav) {
      var card = el.closest('.lxh-fav__card');
      var track = fav.querySelector('[data-lxh-fav-track]');
      if (card && track) {
        var cards = $all(track, '.lxh-fav__card');
        var i = cards.indexOf(card);
        if (i > -1) {
          cards.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
          track.style.setProperty('--lxh-fav-offset', String((cards.length - 1) / 2 - i));
          track.style.setProperty('--lxh-fav-index', String(i));
        }
      }
      return;
    }
    var item = el.closest('[data-lxh-rit-item]');
    if (item) {
      var list = el.closest('[data-lxh-ritual]');
      if (list) $all(list, '[data-lxh-rit-item]').forEach(function (it) { it.classList.toggle('is-active', it === item); });
      return;
    }
    var panel = el.closest('.lxh-pil__panel');
    if (panel) { panel.scrollIntoView({ inline: 'nearest', block: 'nearest' }); }
  });

  window.LuxeHome = LuxeHome;
  document.addEventListener('shopify:section:load', function (e) { LuxeHome.init(e.target); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { LuxeHome.init(document); }); }
  else { LuxeHome.init(document); }
})();
